module.exports = __webpack_public_path__ + "static/media/Pencil.56c70556.svg";